import React from 'react';
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import HomePage from './HomePage';
import PolarisPage from './PolarisPage';
import PolarisTestTypesPage from './PolarisTestTypesPage';
import PolarisSubmitJobPage from './PolarisSubmitJobPage';
import PolarisCreateTestTypePage from './PolarisCreateTestTypePage';

import SwaggerPage from './SwaggerPage';
import ExamplePage from './ExamplePage';

const useStyles = makeStyles({
  content: {
    flex: 1,
    ...shorthands.padding('20px'),
    backgroundColor: tokens.colorNeutralBackground1,
    overflowY: 'hidden',
    overflowX: 'hidden',
  },
  contentNoPadding: {
    flex: 1,
    backgroundColor: tokens.colorNeutralBackground1,
    overflowY: 'hidden',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  contentNoPaddingScrollable: {
    flex: 1,
    backgroundColor: tokens.colorNeutralBackground1,
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
});

function MainContent({ selectedPage, isAuthenticated, onLogin }) {
  const classes = useStyles();
  const isNoPaddingPage =
    selectedPage === 'swagger' ||
    selectedPage === 'home' ||
    selectedPage.startsWith('polaris');
  const usesOuterScroll = selectedPage === 'polaris/submit';
  
  // Swagger and Home pages do not need margins
  const contentClass = isNoPaddingPage
    ? (usesOuterScroll ? classes.contentNoPaddingScrollable : classes.contentNoPadding)
    : classes.content;

  return (
    <div className={contentClass}>
      {selectedPage === 'home' && <HomePage isAuthenticated={isAuthenticated} onLogin={onLogin} />}
      {selectedPage === 'polaris' && <PolarisPage />}
      {selectedPage === 'polaris/submit' && <PolarisSubmitJobPage />}
      {selectedPage === 'polaris/test-types/create' && <PolarisCreateTestTypePage />}
      {selectedPage === 'polaris/test-types' && <PolarisTestTypesPage />}

      {selectedPage === 'swagger' && <SwaggerPage />}
      {(selectedPage === 'example' || selectedPage === 'admin/debug') && <ExamplePage />}
    </div>
  );
}

export default MainContent;